/** @jsxImportSource @emotion/react */
import 'twin.macro';

import { SummaryMetric } from '../SummaryMetric';
import { UsageSummaryMetrics } from 'services/usage-tracking.service';
import { formatMinutesToDuration, formatSecondsToDuration } from 'utils/usageTracking.util';
import { useMemo } from 'react';

type SummaryMetricsSectionProps = {
  metrics: UsageSummaryMetrics | null;
  isLoading: boolean;
};

const numberFormatter = new Intl.NumberFormat('en-US');

export const SummaryMetricsSection = ({
  metrics,
  isLoading,
}: SummaryMetricsSectionProps) => {
  const { hours, calls, computeTime } = useMemo(() => {
    if (isLoading) {
      return { hours: '—', calls: '—', computeTime: '—' };
    }

    return {
      // totalHoursTranscribed is actually in minutes
      hours: formatMinutesToDuration(metrics?.totalHoursTranscribed ?? 0),
      calls: numberFormatter.format(metrics?.apiCalls ?? 0),
      // totalComputeTimeSeconds is in seconds
      computeTime: formatSecondsToDuration(metrics?.totalComputeTimeSeconds ?? 0),
    };
  }, [isLoading, metrics]);

  return (
    <div tw="flex flex-row bg-gray-50 rounded-lg my-6 p-8 space-x-8 md-down:(flex-col space-x-0 space-y-4 p-4)">
      <SummaryMetric title="Total hours transcribed" value={String(hours)} />
      <SummaryMetric title="API calls" value={String(calls)} />
      <SummaryMetric title="Total compute time" value={String(computeTime)} />
    </div>
  );
};
